import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { Http } from "@angular/http";
import { AlertController, LoadingController, ModalController } from "ionic-angular";
import { HomePage } from "../home/home";

import config from "../../config/config";


/**
 * Generated class for the LivroCaixaPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-livro-caixa',
  templateUrl: 'livro-caixa.html',
})
export class LivroCaixaPage {
  file = null;

  tipo = null
  date = null
  constructor(
    public navCtrl: NavController,
    private _http: Http,
    private alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    public navParams: NavParams,
    public modalCtrl: ModalController) {
  }

  ionViewDidLoad() {
    // console.log('ionViewDidLoad LivroCaixaPage');
  }
  arquivo(event) {
    this.file = <File>event.target.files[0];
  }
  subirImage() {
    let imagem = this.file;

    let ano = this.date.split("-")[0]
    let mes = this.date.split("-")[1]
    const fd = new FormData();
    fd.append("arquivo", imagem, imagem.name);
    fd.append("mes", mes);
    fd.append("ano", ano);

    let url = config.urlAPI + "livrocaixa/arquivo";
    if (this.tipo == "1") {
      url = config.urlAPI + "livrocaixa/arquivopen";
    }
    let alert = this.alertCtrl.create({
      title: "Está operação",
      subTitle: "Demanda um longo tempo após o término você será notificado e apenas após ser notificado poderá fazer o envio de outro arquivo.",
      buttons: [
        {
          text: "OK",
          handler: data => {

            this.navCtrl.setRoot(HomePage, {

            });
          }
        }
      ]
    });
    alert.present();
    this._http
      .post(url, fd, {})
      .map(res => res.json())
      .toPromise()
      .then(res => {
        console.log(res);
      })
      .catch(error => {
        console.log(error);
      });
  }
  salvarDados() {
    if (this.file == null || this.date == null || this.tipo == null) {

      let alert = this.alertCtrl.create({
        title: "Obrigatórios",
        subTitle: "Todos os campos de Informações de Arquivo são obrigatórios ",
        buttons: [
          {
            text: "OK",
            handler: data => { }
          }
        ]
      });
      alert.present();
      return true;

    }
    let ano = this.date.split("-")[0]
    let mes = this.date.split("-")[1]
    let verificar = config.urlAPI + "livrocaixa/verificarmes/" + ano + "/" + mes;


    this._http
      .get(verificar, {})
      .map(res => res.json())
      .toPromise()
      .then(res => {
        let titulo = "Está operação";
        let mnsg = "Não pode ser concluida pois não existe informação para o mês e ano selecionado."
        let troca = null;

        if (res.id) {
          this.subirImage();
        } else {
          let alert = this.alertCtrl.create({
            title: titulo,
            subTitle: mnsg,
            buttons: [
              {
                text: "OK",
                handler: data => {
                  troca

                }
              }
            ]
          });
          alert.present();
        }
      })
      .catch(error => {
        console.log(error);
      });
    return true;
  }
  alimentarDados() {
    if (this.date == null) {
      let alert = this.alertCtrl.create({
        title: "Obrigatórios",
        subTitle: "O Campo de Alimentar banco de dados e obrigatorio para essa função",
        buttons: [
          {
            text: "OK",
            handler: data => { }
          }
        ]
      });
      alert.present();
      return true;
    }
    let ano = this.date.split("-")[0]
    let mes = this.date.split("-")[1]
    let url = config.urlAPI + "livrocaixa/criarMes/" + ano + "/" + mes;

    let verificar = config.urlAPI + "livrocaixa/verificarmes/" + ano + "/" + mes;
    this._http
      .get(verificar, {})
      .map(res => res.json())
      .toPromise()
      .then(res => {
        console.log(res);
        let titulo = "Está operação";
        let mnsg = "Não pode ser concluida pois ja existe informação para o mês e ano selecionado."
        let troca = null;

        if (!res.id) {
          titulo = "Está operação";
          mnsg = "Demanda um longo tempo após o término você será notificado e apenas após ser notificado poderá fazer o envio do arquivo para o mês que acabou de alimentar no banco de dados."
          troca = this.navCtrl.setRoot(HomePage, {

          });
          this._http
            .get(url, {})
            .map(res => res.json())
            .toPromise()
            .then(res => {
            })
            .catch(error => {
              console.log(error);
            });

        }
        let alert = this.alertCtrl.create({
          title: titulo,
          subTitle: mnsg,
          buttons: [
            {
              text: "OK",
              handler: data => {
                troca

              }
            }
          ]
        });
        alert.present();

      })
      .catch(error => {
        console.log(error);
      });

  }
}



// WEBPACK FOOTER //
// ./src/pages/livro-caixa/livro-caixa.ts